import { createStore, combineReducers } from 'redux';
import { chatButtonReducer } from './chatButtonRedux';

const rootReducer = combineReducers({
  chatButton: chatButtonReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export const store = createStore(rootReducer);
